import { useEffect, useState } from 'react';
import { siteStatService } from '../services/api';

export const DEFAULT_SITE_STATS = [
  { stat_value: '10M', stat_label: 'Total donation' },
  { stat_value: '20k', stat_label: 'Projects funded' },
  { stat_value: '300', stat_label: 'Kids need help' },
  { stat_value: '22', stat_label: 'Our volunteers' },
];

function normalizeStats(list) {
  if (!Array.isArray(list) || list.length === 0) return DEFAULT_SITE_STATS;
  return list
    .filter((row) => row && (row.is_active === undefined || row.is_active === null || row.is_active === 1 || row.is_active === true || row.is_active === '1'))
    .sort((a, b) => (Number(a.display_order) || 0) - (Number(b.display_order) || 0))
    .map((row) => ({
      id: row.id,
      stat_value: row.stat_value || row.value || '',
      stat_label: row.stat_label || row.label || '',
    }))
    .filter((row) => row.stat_value && row.stat_label);
}

export default function useSiteStats() {
  const [stats, setStats] = useState(DEFAULT_SITE_STATS);

  useEffect(() => {
    let cancelled = false;
    siteStatService
      .getAll()
      .then((res) => {
        const payload = res?.data?.data ?? res?.data;
        const next = normalizeStats(payload);
        if (!cancelled && next.length) setStats(next);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return stats;
}
